module.exports = __webpack_public_path__ + "assets/98f26d554871ad33fdb3f9a2e79d922c.mp3";